export interface ITransactionStatistics {
  total: number;
  depositOrders: number;
  withdrawOrders: number;
  internalOrders: number;
  swapOrders: number;
  cardsIssueOrders: number;
  cardTopUpsOrders: number;
  cardTransactionOrders: number;
  referralTransactionOrders: number;
  totalVolume: number;
}

export enum EOrderType {
  ALL = 'allTxs',
  DEPOSIT = 'deposit',
  WITHDRAW = 'withdraw',
  SWAP = 'swap',
  INTERNAL = 'internal',
  BLOCKED_DEPOSIT = 'blocked-deposit',
  BLOCKED_WITHDRAW = 'blocked-withdraw',
  CARD_ISSUE = 'card-issue',
  CARD_TOP_UP = 'card-top-up',
  CARD_WITHDRAW = 'card-withdraw',
  CARD_TRANSACTION = 'card-transaction',
  REFERRAL_TRANSACTION = 'referral-transaction',
  AML_WALLET_CHECK = 'aml-wallet-check',
  AML_TX_CHECK = 'aml-tx-check',
}

export const SHOW_OPERATION_DIRECTION_TYPES = [
  EOrderType.DEPOSIT,
  EOrderType.WITHDRAW,
  EOrderType.CARD_TOP_UP,
  EOrderType.CARD_WITHDRAW,
  EOrderType.CARD_TRANSACTION,
  EOrderType.CARD_ISSUE,
  EOrderType.REFERRAL_TRANSACTION,
  EOrderType.AML_WALLET_CHECK,
  EOrderType.AML_TX_CHECK,
  EOrderType.INTERNAL,
];

export enum EOrderCurrency {
  All = 'all',
  USDT = 'USDT',
  USDC = 'USDC',
  TRX = 'TRX',
  SOL = 'SOL',
  BTC = 'BTC',
  ETH = 'ETH',
}

export enum EOrderStatus {
  ALL = 'all',
  PROCESSING = 'processing',
  PENDING = 'pending',
  COMPLETED = 'completed',
  FAILED = 'failed',
  BLOCKED = 'blocked',
  REJECTED = 'rejected',
  REFUNDED = 'refunded',
}

// Reusable status options for dropdowns (excludes ALL which is only for filtering)
export const ORDER_STATUS_OPTIONS: { value: EOrderStatus; label: string }[] = [
  { value: EOrderStatus.PROCESSING, label: 'Processing' },
  { value: EOrderStatus.PENDING, label: 'Pending' },
  { value: EOrderStatus.COMPLETED, label: 'Completed' },
  { value: EOrderStatus.FAILED, label: 'Failed' },
  { value: EOrderStatus.BLOCKED, label: 'Blocked' },
  { value: EOrderStatus.REJECTED, label: 'Rejected' },
  { value: EOrderStatus.REFUNDED, label: 'Refunded' },
];
